<button mat-icon-button (click)="onToggleNavigation()">
    <mat-icon svgIcon="heroicons_outline:bars-3"></mat-icon>
</button>
<div *ngIf="!isProduction" class="hidden sm:flex bg-red-600 border border-red-800 text-white px-4 py-1.5 rounded-full text-[11px] font-bold uppercase tracking-wider items-center gap-2 ml-4 shadow-md">
    <mat-icon style="font-size: 16px; width: 16px; height: 16px; line-height: 16px; color: white;">warning</mat-icon>
    <span>Entorno de Pruebas</span>
</div>
<div class="component-header">
    <button mat-icon-button type="button" [matMenuTriggerFor]="notificationsMenuHeader">
        <ng-container *ngIf="unreadCountNotifi > 0">
            <span class="notification-badge-body">
                <span class="notification-badge-text bg-teal-600">
                    {{unreadCountNotifi}}
                </span>
            </span>
        </ng-container>
        <mat-icon svgIcon="heroicons_outline:bell"></mat-icon>
    </button>
    <div class="flex flex-col items-end mr-3 hidden sm:flex">
        <span class="text-sm font-bold text-gray-800 leading-none mb-1">{{dataUser?.cNombreCompleto}}</span>
        <div class="flex items-center gap-1 text-xs">
            <span class="font-medium text-gray-600">{{dataUser?.cPerfil}}</span>
            <span class="text-gray-400">|</span>
            <span class="text-indigo-600 font-semibold uppercase">{{dataUser?.cInstitucion}}</span>
        </div>
    </div>
    <button mat-icon-button [matMenuTriggerFor]="userActions" type="button">
        <span class="relative">
            <img *ngIf="userPhoto" class="w-7 h-7 rounded-full" [src]="'data:image/jpeg;base64,' + userPhoto">
            <mat-icon *ngIf="!userPhoto" svgIcon="heroicons_outline:user-circle"></mat-icon>
            <!-- <span class="absolute right-0 bottom-0 w-2 h-2 rounded-full"></span> -->
        </span>

    </button>
</div>

<mat-menu [xPosition]="'before'" #userActions="matMenu" class="custom-menu">
    <button mat-menu-item style="display: none;"></button>
    <div class="px-4 py-3 outline-none" tabindex="-1">
        <span class="flex flex-col leading-none">
            <span class="font-bold mb-1">{{dataUser?.cNombreCompleto || "Nombre usuario"}}</span>
            <span class="text-xs text-gray-600">{{dataUser?.cPerfil}}</span>
            <span class="text-xs text-gray-500 italic">{{dataUser?.cInstitucion}}</span>
        </span>
    </div>

    <!-- Mi Perfil -->
    <ng-container *ngIf="showMiPerfil">
        <mat-divider class="my-2"></mat-divider>
        <button mat-menu-item (click)="onVerPerfil()">
            <mat-icon [svgIcon]="'heroicons_outline:user'"></mat-icon>
            <span>Mi Perfil</span>
        </button>
    </ng-container>

    <!-- Opciones de Cambio de Institución -->
    <ng-container *ngIf="showCambiarInstitucion">
        <button mat-menu-item [matMenuTriggerFor]="institutionsMenu" (click)="setExpandedCurrentInst()">
            <mat-icon [svgIcon]="'heroicons_outline:building-office-2'"></mat-icon>
            <span>Cambiar Institución</span>
        </button>
    </ng-container>

    <!-- Cierre de Sesión -->
    <ng-container *ngIf="showCerrarSesion">
        <mat-divider class="my-2"></mat-divider>
        <button mat-menu-item (click)="signOut()">
            <mat-icon [svgIcon]="'heroicons_outline:arrow-right-on-rectangle'"></mat-icon>
            <span>Cerrar Sesión</span>
        </button>
    </ng-container>
</mat-menu>



<!-- Expanding Institutions Menu -->
<mat-menu #institutionsMenu="matMenu" panelClass="max-h-[380px] !overflow-y-auto !overflow-x-hidden !min-w-[280px]">
    <button mat-menu-item style="display: none;"></button>
    <ng-container *ngIf="isLoadingHeaderMenu">
        <div class="px-6 py-6 flex flex-col items-center justify-center gap-2">
            <mat-spinner diameter="24"></mat-spinner>
            <span class="text-xs text-gray-500">Cargando instituciones...</span>
        </div>
    </ng-container>

    <ng-container *ngIf="!isLoadingHeaderMenu && headerMenuGroups.length === 0">
        <div class="px-6 py-5 text-sm text-gray-500 text-center italic">
            No tienes instituciones ni perfiles.
        </div>
    </ng-container>

    <!-- Accordion Item -->
    <ng-container *ngFor="let group of headerMenuGroups">

        <!-- Accordion Header (Clickable Div) -->
        <div (click)="toggleInstitution(group.inst.uuid, $event)"
            class="px-4 py-3 border-b border-gray-100 flex items-center justify-between cursor-pointer hover:bg-slate-50 transition-colors"
            [ngClass]="group.inst.uuid === dataUser?.institutionId ? 'bg-indigo-50/60 hover:bg-indigo-100/40 border-indigo-100' : 'bg-white'">

            <div class="flex items-center gap-2">
                <mat-icon class="icon-sm"
                    [svgIcon]="group.inst.uuid === dataUser?.institutionId ? 'heroicons_solid:building-office-2' : 'heroicons_outline:building-office-2'"
                    [ngClass]="group.inst.uuid === dataUser?.institutionId ? 'text-indigo-600' : 'text-slate-400'">
                </mat-icon>
                <span class="text-[13px] font-bold tracking-tight uppercase"
                    [ngClass]="group.inst.uuid === dataUser?.institutionId ? 'text-indigo-800' : 'text-slate-600'">
                    {{group.inst.name}}
                </span>
            </div>

            <mat-icon class="icon-sm text-slate-400 transition-transform duration-200"
                [class.rotate-180]="expandedInstitutionId === group.inst.uuid"
                [svgIcon]="'heroicons_outline:chevron-down'">
            </mat-icon>
        </div>

        <!-- Accordion Content (Roles) -->
        <div class="bg-slate-50 overflow-hidden transition-all duration-300"
            [ngClass]="expandedInstitutionId === group.inst.uuid ? 'max-h-[500px] border-b border-gray-100' : 'max-h-0'">

            <ng-container *ngIf="group.roles.length === 0">
                <div class="px-8 py-3 text-xs text-red-500 italic pb-3">Sin roles en esta entidad.</div>
            </ng-container>

            <div class="py-1">
                <ng-container *ngFor="let role of group.roles">
                    <!-- Active role -->
                    <button *ngIf="group.inst.uuid === dataUser?.institutionId && role.uuid === dataUser?.roleId"
                        mat-menu-item disabled
                        class="opacity-100 !flex justify-between w-full !h-[40px] !leading-[40px] cursor-default">
                        <div class="flex items-center gap-3 ml-2">
                            <mat-icon [svgIcon]="'heroicons_solid:check-circle'"
                                class="text-emerald-500 icon-sm"></mat-icon>
                            <span class="text-slate-900 font-bold text-[13px]">{{role.name}}</span>
                        </div>
                    </button>

                    <!-- Inactive role -->
                    <button *ngIf="!(group.inst.uuid === dataUser?.institutionId && role.uuid === dataUser?.roleId)"
                        mat-menu-item (click)="onSelectHeaderRole(group.inst.uuid, role.uuid)"
                        class="!h-[40px] !leading-[40px] hover:bg-slate-100 transition-colors">
                        <div class="flex items-center gap-3 ml-2 group">
                            <div class="w-1 h-1 rounded-full bg-slate-300 group-hover:bg-indigo-500 transition-colors">
                            </div>
                            <span
                                class="text-slate-600 group-hover:text-indigo-700 font-medium text-[13px] transition-all">{{role.name}}</span>
                        </div>
                    </button>
                </ng-container>
            </div>
        </div>

    </ng-container>
</mat-menu>

<!-- Notifications Inbox Menu -->
<mat-menu #notificationsMenuHeader="matMenu"
    panelClass="notifications-panel-wide max-h-[500px] !overflow-y-auto !overflow-x-hidden !min-w-[380px] !max-w-[480px] p-0 custom-menu shadow-2xl">
    <button mat-menu-item style="display: none;"></button>

    <div
        class="px-5 py-3 border-b border-gray-100 flex items-center justify-between pointer-events-none sticky top-0 z-10 bg-white shadow-[0_1px_2px_rgba(0,0,0,0.02)]">
        <div class="flex items-center gap-2">
            <mat-icon class="icon-sm text-teal-600" svgIcon="heroicons_outline:bell"></mat-icon>
            <span class="text-sm font-bold tracking-tight text-gray-800 leading-none mt-0.5">Notificaciones</span>
        </div>
        <span *ngIf="unreadCountNotifi > 0"
            class="text-[0.65rem] bg-teal-50 text-teal-600 px-2.5 py-1 rounded-full font-bold border border-teal-100 uppercase tracking-widest leading-none mt-0.5">
            {{unreadCountNotifi}} nuevas
        </span>
    </div>

    <ng-container *ngIf="isLoadingNotificaciones">
        <div class="p-8 flex flex-col items-center justify-center gap-3">
            <mat-spinner diameter="24"></mat-spinner>
            <span class="text-xs text-gray-500 font-medium animate-pulse">Cargando bandeja...</span>
        </div>
    </ng-container>

    <ng-container *ngIf="!isLoadingNotificaciones">
        <div *ngIf="inboxNotificaciones.length === 0" class="p-8 text-center flex flex-col items-center">
            <div
                class="w-14 h-14 bg-gray-50 border border-dashed border-gray-200 rounded-full flex items-center justify-center mb-4">
                <mat-icon class="text-gray-300" svgIcon="heroicons_outline:inbox"></mat-icon>
            </div>
            <p class="text-[0.85rem] font-bold text-gray-900 mb-1">¡Todo al día!</p>
            <p class="text-xs font-medium text-gray-500 leading-relaxed">No tienes notificaciones<br>nuevas por ahora.
            </p>
        </div>

        <div class="flex flex-col py-1">
            <!-- (click) using stopPropagation ensures it won't close if we navigate manually or want to keep it open, 
                 but if we want it to close on click naturally, just let it bubble -->
            <button mat-menu-item *ngFor="let notif of inboxNotificaciones" (click)="onNotificationClick(notif, $event)"
                class="!h-auto !whitespace-normal border-b border-gray-50/80 last:border-0 hover:bg-slate-50 transition-colors py-2 px-3 relative"
                [ngClass]="notif.estadoId < 3 ? 'bg-indigo-50/30' : ''">

                <!-- Unread indicator stripe -->
                <div *ngIf="notif.estadoId < 3" class="absolute left-0 top-0 bottom-0 w-1 bg-teal-500"></div>

                <div class="flex items-start gap-3" [ngClass]="notif.estadoId < 3 ? 'ml-1' : ''">
                    <div class="flex-shrink-0 mt-0.5 relative">
                        <!-- Unread: closed envelope -->
                        <div *ngIf="notif.estadoId < 3"
                            class="w-8 h-8 rounded-full bg-teal-100 text-teal-600 flex items-center justify-center shadow-sm border border-teal-200">
                            <mat-icon class="!text-[18px] !w-[18px] !h-[18px] leading-none"
                                style="margin-right: 0px;">mail</mat-icon>
                        </div>
                        <!-- Read: open envelope -->
                        <div *ngIf="notif.estadoId >= 3"
                            class="w-8 h-8 rounded-full bg-gray-100 text-gray-400 flex items-center justify-center shadow-sm border border-gray-200">
                            <mat-icon class="!text-[18px] !w-[18px] !h-[18px] leading-none"
                                style="margin-right: 0px;">drafts</mat-icon>
                        </div>
                    </div>

                    <div class="flex flex-col flex-1 min-w-0">
                        <div class="flex items-start justify-between gap-2 mb-0 w-full">
                            <span class="text-xs font-bold text-gray-900 truncate pr-2 w-full text-left"
                                [ngClass]="notif.estadoId < 3 ? 'text-indigo-900' : 'text-gray-800'">
                                {{notif.titulo}}
                            </span>
                            <span class="text-[0.65rem] font-medium text-gray-400 whitespace-nowrap">{{notif.createdAt
                                | date:'shortDate'}}</span>
                        </div>
                        <div class="flex items-center gap-2 mt-0 w-full min-w-0">
                            <span
                                class="text-[0.60rem] uppercase tracking-wider font-bold px-1.5 py-0.5 rounded-md border whitespace-nowrap flex-shrink-0 max-w-[150px] truncate leading-tight"
                                [ngClass]="notif.estadoId < 3 ? 'bg-indigo-50 text-indigo-600 border-indigo-100' : 'bg-gray-100 text-gray-600 border-gray-200'"
                                [title]="notif.remitente?.roleName">
                                {{notif.remitente?.roleName}}
                            </span>
                            <span class="text-[0.7rem] text-gray-500 truncate font-medium flex-1 text-right"
                                [title]="notif.remitente?.nombreCompleto">
                                {{formatShortName(notif.remitente?.nombreCompleto) | titlecase}}
                            </span>
                        </div>
                    </div>
                </div>
            </button>
        </div>

        <div class="p-2 border-t border-gray-100 sticky bottom-0 bg-white/95 backdrop-blur z-10"
            *ngIf="inboxNotificaciones.length > 0">
            <button mat-button class="w-full !text-indigo-600 hover:!bg-indigo-50/50 rounded-lg transition-colors"
                (click)="onVerTodasNotificaciones()">
                <span class="text-xs font-bold w-full uppercase tracking-wider">Ver todas las notificaciones</span>
            </button>
        </div>
    </ng-container>
</mat-menu>